import { render, staticRenderFns } from "./SoftSkillsEditor.vue?vue&type=template&id=5d320397&"
import script from "./SoftSkillsEditor.vue?vue&type=script&lang=ts&"
export * from "./SoftSkillsEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports